const B = "https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/ca102a97-52cb-4aa3-835d-c01eb600a0b4/";
const D = "https://lh3.googleusercontent.com/d/";

// Imágenes WebP alojadas en Recursos de Impultienda
export const IMAGE_MAP: Array<[string, string]> = [
  [D + "10pfRuzOpoivVupdNZmpzkxrwJdLtA3_I", B + "1792559388580_mockup-reconecta-d2ef844d.webp"],
  [D + "1qasvHudBS_DXK61ckWVwJTQWYaiVlVgW", B + "1792527269263_b1-cover.webp"],
  [D + "17MD6LMJiLa_99Bf4L269HkHBgtsukmA_", B + "1792527269904_b1-photo.webp"],
  [D + "1-nq1Z4l-Kc3uRDwpae-BADz-8Q6fihU6", B + "1792527270539_b2-photo.webp"],
  [D + "1L_MVMtdNOZUHq4I38w7EQJFCdWppFB-6", B + "1792527271185_b3-photo.webp"],
  [D + "1fkGG8E25ZtYJ-s4HBAjykM14q3HcjwLI", B + "1792527271847_t3-cover.webp"],
  [D + "10LugJMb_vsslKSbOS3e__Pmyydr4QwKx", B + "1792527272510_t4-cover.webp"],
  [D + "19fmS830iOFYxAjqhrt7ZcwrZzXC3txY8", B + "1792527273164_t5-cover.webp"],
  [D + "1ASV5Sz__Oqsnw-hftcREorzEtYSYX-rl", B + "1792527273944_u1-photo.webp"],
  [D + "1Z7Oco37JKPzbGIX7Iv7pGTRmXfEG-Q2p", B + "1792527274588_u2-photo.webp"],
];

export function applyImageMap(text: string): string {
  let out = text;
  for (const [from, to] of IMAGE_MAP) out = out.split(from).join(to);
  // El script arma las URLs con un prefijo + id; se resuelve igual porque el id queda dentro del texto reemplazado.
  return out;
}
